package oldframes.segments.static

import ru.it_mozaika.sender.common.EMAIL_REGEX
import bootstrap.*
import ru.it_mozaika.utils.checkResponseError
import oldcomponents.NotyType
import oldcomponents.showNotification
import kotlinx.css.Display
import kotlinx.css.display
import kotlinx.html.InputType
import kotlinx.html.id
import kotlinx.html.js.onBlurFunction
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import kotlinx.html.role
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement
import org.w3c.files.FileReader
import org.w3c.files.get
import react.*
import react.dom.*
import ru.it_mozaika.sender.common.models.StaticSegmentEmailsAction
import ru.it_mozaika.sender.common.models.StaticSegmentUpdateEmailsRequest
import ru.it_mozaika.sender.js.application.Http
import styled.styledForm
import styled.styledInput

external interface UploadEmailsDialogProps : Props {
    var segmentId: String?
    var onClose: (Boolean) -> Unit
}
val uploadSegmentsDialog = fc<UploadEmailsDialogProps> { props ->
    var activeTab by useState(0)
    var emails by useState(listOf<String>())
    var action by useState(StaticSegmentEmailsAction.Add)

    var emailsInputValue by useState("")

    useEffect(props.segmentId) {
        if (undefined == props.segmentId || null == props.segmentId) {
            emailsInputValue = ""
            emails = listOf()
            action = StaticSegmentEmailsAction.Add
        }
    }

    val fileInputRef = useRef<HTMLInputElement>()
    styledForm {
        css.display = Display.none
        styledInput(InputType.file) {
            css.display = Display.none
            ref = fileInputRef
            attrs.accept = ".csv"
            attrs.multiple = false
            attrs.onChangeFunction = { e ->
                (e.target as? HTMLInputElement)?.let { input ->
                    input.files?.get(0)?.let { file ->

                        val reader = FileReader()
                        reader.onload = { _ ->
                            val text = reader.result as String
                            val values = text
                                .split("\n")
                                .mapNotNull { row -> row.split(",").firstOrNull() }
                            val result = values.mapNotNull {
                                val email = it.trim().lowercase()
                                if (EMAIL_REGEX.matches(email)) {
                                    email
                                } else {
                                    null
                                }
                            }
                            showNotification("Подготовлено ${result.size} адресов из ${values.size} введенных значений", NotyType.Info)
                            emails = result
                            result
                        }
                        reader.readAsText(file)
                    }
                    input.value = ""
                }
            }
        }
    }

    Modal {
        attrs.show = undefined != props.segmentId && null != props.segmentId
        attrs.size = "lg"
        attrs.onHide = { props.onClose(false) }
        ModalHeader {
            ModalTitle {
                +"Загрузка список Email-адресов"
            }
        }
        ModalBody {
            div("alert alert-outline-primary") {
                attrs.role = "alert"
                +"Готово к загрузке ${emails.size} адресов"
            }

            div("form-group row d-flex align-items-center mt-4 mb-1") {
                label("col-3 form-control-label") { +"Выберите действие:" }
                div("col-3") {
                    div("styled-radio") {
                        input(type = InputType.radio) {
                            attrs.id = "action-add"
                            attrs["checked"] = action == StaticSegmentEmailsAction.Add
                            attrs.onChange = {
                                (it.target as? HTMLInputElement)?.checked?.let { v ->
                                    if (v) {
                                        action = StaticSegmentEmailsAction.Add
                                    }
                                }
                            }
                        }
                        label {
                            attrs["htmlFor"] = "action-add"
                            +"Добавить"
                        }
                    }
                }
                div("col-3") {
                    div("styled-radio") {
                        input(type = InputType.radio) {
                            attrs.id = "action-remove"
                            attrs["checked"] = action == StaticSegmentEmailsAction.Remove
                            attrs.onChange = {
                                (it.target as? HTMLInputElement)?.checked?.let { v ->
                                    if (v) {
                                        action = StaticSegmentEmailsAction.Remove
                                    }
                                }
                            }
                        }
                        label {
                            attrs["htmlFor"] = "action-remove"
                            +"Удалить"
                        }
                    }
                }
                div("col-3") {
                    div("styled-radio") {
                        input(type = InputType.radio) {
                            attrs.id = "action-replace"
                            attrs["checked"] = action == StaticSegmentEmailsAction.Replace
                            attrs.onChange = {
                                (it.target as? HTMLInputElement)?.checked?.let { v ->
                                    if (v) {
                                        action = StaticSegmentEmailsAction.Replace
                                    }
                                }
                            }
                        }
                        label {
                            attrs["htmlFor"] = "action-replace"
                            +"Заменить"
                        }
                    }
                }
            }

//            Nav {
//                attrs.activeKey = activeTab
//                attrs.onSelect = { key, _ ->
//                    activeTab = (key as String).toInt()
//                }
//                attrs.variant = "tabs"
//                attrs.fill = true
//                NavItem {
//                    NavLink {
//                        attrs.eventKey = 0
//                        attrs.role = "tab"
//                        +"Загрузить файл"
//                    }
//                }
//                NavItem {
//                    NavLink {
//                        attrs.eventKey = 1
//                        attrs.role = "tab"
//                        +"Ввести вручную"
//                    }
//                }
//            }
            TabContent {
                TabPane {
                    attrs.active = activeTab == 0
                    div("form-group row d-flex align-items-center mb-5 mt-3") {
                        label("col-6 form-control-label") { +"Выберите csv-файл для загрузки:" }
                        div("col-6") {
                            button(type = kotlinx.html.ButtonType.button, classes = "btn btn-primary") {
                                attrs.onClickFunction = {
                                    fileInputRef.current?.click() ?: kotlin.run {
                                        showNotification("Неизвестная ошибка", NotyType.Error)
                                    }
                                }
                                +"Загрузить"
                            }
                        }
                    }
                }
                TabPane {
                    attrs.active = activeTab == 1

                    div("form-group row d-flex align-items-center mb-5 mt-3") {
                        label("col-3 form-control-label") { +"Email-адреса через ';':" }
                        div("col-9") {
                            textarea(classes = "form-control") {
                                attrs.value = emailsInputValue
                                attrs.onBlurFunction = onBlur@{
                                    if (emailsInputValue.isBlank()) {
                                        emailsInputValue = ""
                                        emails = listOf()
                                        return@onBlur
                                    }
                                    val values = emailsInputValue.split(";")
                                    val result = values.mapNotNull {
                                        val email = it.trim().lowercase()
                                        if (EMAIL_REGEX.matches(email)) {
                                            email
                                        } else {
                                            null
                                        }
                                    }
                                    showNotification("Подготовлено ${result.size} адресов из ${values.size} введенных значений", NotyType.Info)
                                    emails = result
                                }
                                attrs.onChangeFunction = {
                                    emailsInputValue = (it.target as? HTMLTextAreaElement)?.value.orEmpty()
                                }
                            }
                        }
                    }
                }
            }
        }
        ModalFooter {
            Button {
                attrs.variant = "secondary"
                attrs.onClick = { props.onClose(false) }
                +"Отмена"
            }
            Button {
                attrs.variant = "gradient-01"
                attrs.disabled = emails.isEmpty()
                attrs.onClick = {
                    Http.post("/segments/static/${props.segmentId}/emails", StaticSegmentUpdateEmailsRequest(emails, action)) { response ->
                        response.checkResponseError()?.let { error ->
                            showNotification(error, NotyType.Error)
                            return@post
                        }
                        showNotification("Запрос успешно отправлен", NotyType.Success)
                        props.onClose(true)
                    }
                }
                +"Загрузить"
            }
        }
    }
}